import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-org-delete-department-modal',
  templateUrl: './org-delete-department-modal.component.pug',
  styleUrls: ['./org-delete-department-modal.component.scss'],
  standalone: false
})
export class OrgDeleteDepartmentModalComponent implements OnInit {

  @Input() departmentToDelete: any = [];
  @Input() departmentList: any = [];

  closeModalEvent: EventEmitter<any> = new EventEmitter<any>();

  label = $localize`Please select a department`;

  selectedDepartment: any = null;
  departmentChoices: any = [];
  bannerText = '';
  isValid = true;

  constructor(
    public _bsModalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
    this.departmentChoices = this.departmentList
      .filter(each => each.id !== this.departmentToDelete.id)
      .map(each => ({ value: each.department } ));

    this.departmentChoices.unshift({ value: $localize`No department (Unassigned)` })

    if(this.departmentToDelete.times_used === 1) {
      this.bannerText = $localize`${this.departmentToDelete.times_used} person belongs to ${this.departmentToDelete.department}. You can reassign them before deleting the department.`
    } else {
      this.bannerText = $localize`${this.departmentToDelete.times_used} people belong to ${this.departmentToDelete.department}. You can reassign them before deleting the department.`
    }
  }

  closeModal(){
    this.closeModalEvent.emit({ showConfirmation: false });
    this._bsModalRef.hide();
  }

  save() {
    this.closeModalEvent.emit({ showConfirmation: true, newDepartment: this.selectedDepartment });
    this._bsModalRef.hide();
  }

  dropdownSelect(event) {
  this.selectedDepartment = this.departmentList.find(each => each.department === event.value)
  if(!this.selectedDepartment) this.selectedDepartment = event.value;
  this.isValid = false
  }

}
